function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.667 4.667h-2V4a2.667 2.667 0 00-5.333 0v.667h-2a.667.667 0 00-.667.666v7.334a2 2 0 002 2h6.667a2 2 0 002-2V5.333a.667.667 0 00-.667-.666zm-6-.667a1.333 1.333 0 012.667 0v.667H6.667V4zM12 12.667a.667.667 0 01-.666.666H4.667A.667.667 0 014 12.667V6h1.334v.667a.667.667 0 001.333 0V6h2.667v.667a.667.667 0 001.333 0V6H12v6.667z"
});

function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgShoppingBag;